import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_CHECK_SELF_TOUR_REQUEST } from 'api/actionTypes';

export default async function checkSelfTourRequest({ state, apiClient }, { listingId }) {
  typeCheck('listingId::PositiveNumber', listingId);

  await apiClient.postWithState({
    action: SR_API_ACTION_CHECK_SELF_TOUR_REQUEST,
    state: state,
    queryId: `${listingId}`,
    payload: {
      listingId,
    },
    onSuccess(userUpdated) {
      state.set(['currentUser'], {
        ...state.get(['currentUser']),
        ...userUpdated,
      });
    },
  });
}
